import { render, staticRenderFns } from "./NoGroupsCreated.vue?vue&type=template&id=20dae482&"
import script from "./NoGroupsCreated.vue?vue&type=script&lang=js&"
export * from "./NoGroupsCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports